"use client";

import { getConsent, setConsent } from "@/lib/consent";
import { useEffect, useState } from "react";

export function CookieConsentBanner() {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const consent = getConsent();
		if (consent === "pending") {
			const timer = setTimeout(() => setVisible(true), 500);
			return () => clearTimeout(timer);
		}
	}, []);

	useEffect(() => {
		function handleConsentChange(e: Event) {
			const customEvent = e as CustomEvent;
			if (customEvent.detail === "pending") {
				setVisible(true);
			}
		}
		window.addEventListener("consent-changed", handleConsentChange);
		return () =>
			window.removeEventListener("consent-changed", handleConsentChange);
	}, []);

	function handleAccept() {
		setConsent("granted");
		setVisible(false);
	}

	function handleDecline() {
		setConsent("denied");
		setVisible(false);
	}

	if (!visible) {
		return null;
	}

	return (
		<div
			className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in-up"
			style={{ animationDuration: "0.4s" }}
		>
			<div className="max-w-2xl mx-auto">
				<div className="bg-white rounded-xl shadow-lg border border-gray-200/80 p-4 sm:p-5">
					<div className="flex flex-col sm:flex-row sm:items-center gap-4">
						<div className="flex-1 min-w-0">
							<p className="text-sm text-gray-600 leading-relaxed">
								We use analytics to understand how visitors use our website and
								improve the experience.
							</p>
						</div>
						<div className="flex items-center gap-2 shrink-0">
							<button
								type="button"
								onClick={handleDecline}
								className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
							>
								Decline
							</button>
							<button
								type="button"
								onClick={handleAccept}
								className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors"
							>
								Accept
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
